import React, { FC } from "react";
import { Drawer, List } from "@material-ui/core";
import NavItem from "./NavItem/NavItem";
import { Link as RouterLink } from "react-router-dom";
import useStyles from "./styles";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { getEnabledNavItems } from "../Helpers/getEnabledNavItems";
import navItems from "../SideNav/navItems";
import { whiteLabelPartners } from "Modules/WhiteLabelPartners";
import LinkToOrbit from "./LinkToOrbit/link-to-orbit";
import PermissionVizToggle from "./PermissionVizToggle/permission-viz-toggle";

const SideNav: FC = () => {
  const classes = useStyles();

  const config = usePartnerConfig();
  const { enabledFeatures, permissions, currentProvider } = config;

  const whiteLabelPartner = currentProvider?.whiteLabelPartnerIdentifier;

  const Logo =
    whiteLabelPartners[whiteLabelPartner as keyof typeof whiteLabelPartners];

  // Filter out nav items disabled by Flippers or Permissions
  const enabledNavItems = getEnabledNavItems(
    navItems,
    enabledFeatures,
    permissions,
    config
  );

  return (
    <Drawer
      role="navigation"
      aria-label="main navigation"
      variant="permanent"
      anchor="left"
      classes={{ paper: classes.paper }}
    >
      <RouterLink to="/">
        <Logo height="116" width="207" />
      </RouterLink>
      <List>
        {enabledNavItems.map((navItem) =>
          navItem.label === "Help & Docs" &&
          whiteLabelPartner !== "dailypay" ? null : (
            <NavItem key={navItem.label} {...navItem} />
          )
        )}
      </List>
      <LinkToOrbit />
      <PermissionVizToggle />
    </Drawer>
  );
};

export default SideNav;
